import { ParticipantFace, type ParticipantFaceProps } from './ParticipantFace';
import { CogIcon } from '../icons/CogIcon';
import './OrganizerFace.css';

/** Organizer identity uses the same animal artwork, with its role badge. */
export function OrganizerFace({ compact = false, ...props }: ParticipantFaceProps & { compact?: boolean }) {
  return (
    <span className={`organizer-face${compact ? ' organizer-face--compact' : ''}`}>
      <ParticipantFace {...props} />
      <span className="organizer-face__cog" aria-hidden="true"><CogIcon /></span>
    </span>
  );
}
